import axios from "@/hooks/axios/axios";
import type {
  ClientsResponse,
  ClientOverviewResponse,
  ClientSubscriptionResponse,
  ActivityLogResponse,
  ActivityLogParams,
  ClientTokensResponse,
  DeactivateClientResponse,
} from "../types/client.types";

export const getClients = async (): Promise<ClientsResponse> => {
  const { data } = await axios.get("/clients/list");
  return data;
};

export const getClientOverview = async (
  clientId: string,
): Promise<ClientOverviewResponse> => {
  const { data } = await axios.get(`/clients/${clientId}/overview`);
  return data;
};

export const getClientSubscription = async (
  userId: string,
): Promise<ClientSubscriptionResponse> => {
  const { data } = await axios.get(`/clients/${userId}/subscription`);
  return data;
};

export const getClientActivityLog = async ({
  userId,
  page = 1,
  pageSize = 50,
}: ActivityLogParams): Promise<ActivityLogResponse> => {
  const validatedPageSize = Math.max(1, Math.min(100, pageSize));

  const { data } = await axios.get(`/clients/${userId}/activity`, {
    params: {
      page,
      page_size: validatedPageSize,
    },
  });
  return data;
};

export const getClientTokens = async (
  userId: string,
): Promise<ClientTokensResponse> => {
  const { data } = await axios.get(`/clients/${userId}/tokens`);
  return data;
};

export const revokeClientToken = async (
  userId: string,
  apiKeyId: string,
): Promise<void> => {
  const { data } = await axios.post(
    `/clients/${userId}/api-keys/${apiKeyId}/deactivate`,
  );
  return data;
};

export const deactivateClient = async (
  userId: string,
): Promise<DeactivateClientResponse> => {
  const { data } = await axios.post(`/clients/${userId}/deactivate`);
  return data;
};
